import generateLink from "@/components/table/utils/generateLink";

export default function generatePagesLinks(route, pagesRange, currentPage) {
  const [startPage, endPage] = pagesRange;
  const links = [];

  for (let i = startPage; i <= endPage; i++) {
    links.push({
      label: i.toString(),
      link: generateLink(route, i),
      isActive: i === currentPage,
    });
  }

  return links;
}